import { ICellRendererParams } from "@ag-grid-community/core";
import { Checkbox } from "@chakra-ui/react";
import { FundFamilyUseAllocationTableRow } from "gen/model/fundFamilyUseAllocationTableRow";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FundFamilyUseAllocationTableContext } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableProps";
import { isFundFamilyUseAllocationTableRowEditable } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableUtils";
import { useConfirmationDialog } from "shared/components/modal/confirm/ConfirmationDialog";
import { SimpleConfirmationDialog } from "shared/components/modal/SimpleConfirmationDialog";
import { MaybernTableFocusCellRendererWrapper } from "shared/components/table/maybern/MaybernTableFocusCellRendererWrapper";

export const FundFamilyUseAllocationTableAutoAllocateCellRenderer: React.FC<
  ICellRendererParams<FundFamilyUseAllocationTableRow>
> = (params) => {
  const { t } = useTranslation(["common"]);

  const ref = useRef<HTMLInputElement>(null);
  const {
    tableDef: { categories },
  }: FundFamilyUseAllocationTableContext = params.context;

  const confirmAllocation = useConfirmationDialog(SimpleConfirmationDialog, {
    title: t("common:drawdown.confirmManualAllocation.title"),
    description: t("common:drawdown.confirmManualAllocation.description"),
    confirmButtonProps: {
      colorScheme: "destructive",
    },
  });

  const category = categories.find((c) => c.id === params.data?.category_id);

  if (category?.allow_auto_allocate === false) {
    return undefined;
  }

  const hasAllocatedAmount = Object.values(
    params.node.data?.fund_family ?? {},
  ).some(({ amount }) => !!Number(amount));

  return (
    <MaybernTableFocusCellRendererWrapper params={params} inputRef={ref}>
      <Checkbox
        ref={ref}
        isChecked={params.value}
        onChange={async (e) => {
          const value = e.currentTarget.checked;
          if (!value && hasAllocatedAmount) {
            const result = await confirmAllocation();
            if (!result) {
              return;
            }
          }
          params.setValue?.(value);
        }}
        isDisabled={!isFundFamilyUseAllocationTableRowEditable(params.node)}
      />
    </MaybernTableFocusCellRendererWrapper>
  );
};
